import React from 'react';
import PropTypes from 'prop-types';
import UserAvatar from 'react-native-user-avatar';
import { nameToInitials } from 'src/utils';
import { avatarBgColors } from 'src/constants/theme';
import Common from 'src/components/Common';
import {styles} from './style'

export const Participant = ({ participantName = '', size = 25, style }) => {
  return (
    <Common.View transparent style={[styles.participantAvatar, style]}>
      <UserAvatar
        size={size}
        textColor="lightslategrey"
        name={nameToInitials(participantName || '')}
        bgColors={avatarBgColors}
      />
    </Common.View>
  );
};

Participant.propTypes = {
  participantName: PropTypes.string,
  size: PropTypes.number,
};
